import React from 'react'
import _ from 'lodash'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import immutable from 'immutable'
import axios from 'axios'
import Guid from 'guid'

import {AutoComplete} from '../widgets/autocomplete/autocomplete.component'

const ELASTISEARCH_URL = '/api/v1/destinations/search'

export class TravelEntry extends React.Component {
    constructor(props) {
        super(props)

        let _tempItem = null
        let _fullItem = null
        let _partialItem = null
        let _isAdded = false

        if (!this.props.item) {
            _tempItem = new immutable.fromJS({}) // need an empty one if we don't have one passed in (ex: add my own)
            _partialItem = _tempItem
        } else {
            _tempItem = new immutable.fromJS(this.props.item)
            _fullItem = _tempItem.get('transportation') ? _tempItem : null // full content including dep, arr, etc
            _partialItem = _tempItem.get('transportation')  ? _tempItem.get('transportation') : _tempItem // Just the trans object
            _isAdded = this.props.inItin ? this.props.inItin : this.props.transportation.findIndex((trans) => {
                return trans.getIn(['transportation', 'transportation_guid']) === _partialItem.get('transportation_guid')
            })
        }

        let startdate = null
        let enddate = null

        // TODO: This is a mess but fields have to be a string and some may be undefined, react complains..

        if (this.props.arrivalDate) {
            let start = this.props.leg.getIn(['properties', 'start'])
            let end = this.props.leg.getIn(['properties', 'end'])
            startdate = this.props.arrivalDate.clone()
            enddate = this.props.arrivalDate.clone()
            startdate = startdate.add(start, 'days').format('MMM DD, YYYY')
            enddate = enddate.add(end, 'days').format('MMM DD, YYYY')
        }
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'startdate'])) {
                startdate = _fullItem.getIn(['transportation', 'reservation_details', 'startdate'])
            }
        }
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'enddate'])) {
                enddate = _fullItem.getIn(['transportation', 'reservation_details', 'enddate'])
            }
        }

        let tDepCity = ''
        if (_fullItem) {
            if (_fullItem.get('depCity')) {
                tDepCity = _fullItem.get('depCity')
            } else if (this.props.depCity) {
                tDepCity = this.props.depCity
            }
        }

        let tArrCity = ''
        if (_fullItem) {
            if (_fullItem.get('arrCity')) {
                tArrCity = _fullItem.get('arrCity')
            } else if (this.props.arrCity) {
                tArrCity = this.props.arrCity
            }
        }

        let tStartTime = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'starttime'])) {
                tStartTime = _fullItem.getIn(['transportation', 'reservation_details', 'starttime'])
            }
        }

        let tEndTime = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'endtime'])) {
                tEndTime = _fullItem.getIn(['transportation', 'reservation_details', 'endtime'])
            }
        }

        let tCarrier = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'carrier'])) {
                tCarrier = _fullItem.getIn(['transportation', 'reservation_details', 'carrier'])
            }
        }

        let tTransitType = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'transittype'])) {
                tTransitType = _fullItem.getIn(['transportation', 'reservation_details', 'transittype'])
            }
        }

        let tNotes = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'notes'])) {
                tNotes = _fullItem.getIn(['transportation', 'reservation_details', 'notes'])
            }
        }

        let tNumGuests = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'numguests'])) {
                tNumGuests = _fullItem.getIn(['transportation', 'reservation_details', 'numguests'])
            }
        }

        let tCode = ''
        if (_fullItem) {
            if (_fullItem.getIn(['transportation', 'reservation_details', 'confirmation_code'])) {
                tCode = _fullItem.getIn(['transportation', 'reservation_details', 'confirmation_code'])
            }
        }





        this.state = {
            fullItem: _fullItem,
            partialItem: _partialItem,
            isAdded: _isAdded,
            transname: _partialItem.get('name') ? _partialItem.get('name') : '',
            depCity: tDepCity,
            arrCity: tArrCity,
            startdate: startdate,
            enddate: enddate,
            starttime: tStartTime,
            endtime: tEndTime,
            carrier: tCarrier,
            transittype: tTransitType,
            notes: tNotes,
            numguests: tNumGuests,
            confirmation_code: tCode,
        }

        _.bindAll(this,
            'goBack',
            'updateStartDate',
            'updateEndDate',
            'submitCustomItem',
            'onExecuteQuery',
            'onRenderResult',
            'onChooseDep',
            'onChooseArr',
            'refreshFields',
            'getForm',
            'handleChange'
        )
    }

    handleChange(target, value) {
        this.setState({[target]: value})
    }

    componentDidMount() {
        this.refreshFields()
    }

    refreshFields() {
    // evertime we auto set a field, we have to trigger the class change to move the label up/down
        $('.input-plain input').each(function() {
            var target = $(this)
            if (target.parent().hasClass('react-datepicker__input-container')) {
                // datepicker is nested 1 level deeper
                target.parent().parent().removeClass('is-focused')
                target.val() ? target.parent().parent().addClass('has-value') : target.parent().parent().removeClass('has-value')
            } else {
                target.parent().removeClass('is-focused')
                target.val() ? target.parent().addClass('has-value') : target.parent().removeClass('has-value')
            }
        })
    }

    onExecuteQuery(q) {
        return axios.get(ELASTISEARCH_URL, {
            params: {
                query: q
            }
        }).then((response) => response.data.results)
    }

    componentDidUpdate(prevProps, prevState) {
        this.refreshFields()
    }

    onRenderResult(result) {
        return (
            <div className="result-item">
                <div className="result-label">
                    <div className="result-name">{result.name}</div>
                </div>
            </div>
        )
    }

    onChooseDep(choice) {
        this.setState({depCity: choice})
    }

    onChooseArr(choice) {
        this.setState({arrCity: choice})
    }


    goBack() {
        if (this.props.goBack) {
            this.props.goBack()
        } else {
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.OVERVIEW)
        }
    }

    updateStartDate(evt) {
        let newStartDate = evt ? moment(evt) : null
        if (newStartDate) {
            let startDateAfterEndDate = moment(newStartDate).isAfter(
                this.state.enddate
            )
            if (startDateAfterEndDate) {
                alert('Start date cannot be after End date.')
                return null
            }
            let startDateIsInPast = moment(newStartDate).isBefore(moment())
            if (startDateIsInPast) {
                alert('Staret date cannot be in the past.')
                return null
            }

            this.setState({
                startdate: newStartDate
            })
        }
    }

    updateEndDate(evt) {
        let newEndDate = evt ? moment(evt) : null
        if (newEndDate) {
            let startDateAfterEndDate = moment(newEndDate).isBefore(this.state.startdate)
            if (startDateAfterEndDate) {
                alert('Start date cannot be after End date.')
                return null
            }
            let endDateIsInPast = moment(newEndDate).isBefore(moment())
            if (endDateIsInPast) {
                alert('End date cannot be in the past.')
                return null
            }

            this.setState({
                enddate: newEndDate
            })
        }
    }

    submitCustomItem() {
    // get the form items and pass on
        let arrCity =  this.refs.arrcityinput.value
        if (this.refs.arrcityinput.state) {
            if (this.refs.arrcityinput.state.value) {
                // if using autocomplete
                arrCity = this.refs.arrcityinput.state.value
            }
        }

        let depCity =  this.refs.depcityinput.value
        if (this.refs.depcityinput.state) {
            if (this.refs.depcityinput.state.value) {
                // if using autocomplete
                depCity = this.refs.depcityinput.state.value
            }
        }

        // Need to pass arrLeg, depLeg, arrCity, depCity, user, and transportation object
        let transItem = immutable.fromJS({
            name: this.refs.transname.value ? this.refs.transname.value : 'Custom',
            transportation_guid: this.state.partialItem.get('transportation_guid') ? this.state.partialItem.get('transportation_guid') : Guid.raw(),
            segments: this.state.partialItem.get('segments') ? this.state.partialItem.get('segments') : {},
            totalDuration: this.state.partialItem.get('totalDuration') ? this.state.partialItem.get('totalDuration') : 0,
            reservation_details: {
                confirmation_code: this.refs.confirmation_code.value ? this.refs.confirmation_code.value : '',
                startdate: this.refs.startdate.props.value ? this.refs.startdate.props.value.format('MMMM D, YYYY') : '',
                enddate: this.refs.enddate.props.value ? this.refs.enddate.props.value.format('MMMM D, YYYY') : '',
                transittype: this.refs.transittype.value ? this.refs.transittype.value : '',
                carrier: this.refs.carrier.value ? this.refs.carrier.value : '',
                starttime: this.refs.starttime.value ? this.refs.starttime.value : '',
                endtime: this.refs.endtime.value ? this.refs.endtime.value : '',
                numguests: this.refs.numguests.value ? this.refs.numguests.value : '',
                notes: this.refs.notes.value ? this.refs.notes.value : ''
            }
        })

        // TODO: This is a duplicate function from travelsearch, prop should be centralized and reusable
        // Need to get legs and set arrCity and depCity as needed....
        let newDepCity = this.refs.depcity ? this.refs.depcity : null
        let newArrCity = this.refs.arrCity ? this.refs.arrCity : null
        let depLeg = -1
        let arrLeg = -1

        switch (this.props.detailSubDetail) {
            case 'ARRIVAL':
                // dep is origin, arr is current (origin has slightly different structure)
                depLeg = this.props.prevLeg ? this.props.prevLeg.get('id') : this.props.origination ? this.props.origination.get('id') : -1
                arrLeg = this.props.leg.get('id')
                break
            case 'DEPARTURE':
                // dep is current, arr is return
                depLeg = this.props.leg.get('id')
                arrLeg = this.props.nextLeg ? this.props.nextLeg.get('id') : this.props.return ? this.props.return.get('id') : -1
                break
            case 'LOCAL':
                // dep and arr are both current
                depLeg = this.props.leg.getIn(['id'])
                arrLeg = depLeg
                break
            default:
                // seomthing went wrong...
                alert('Error in onAddTransportation in travelentry.component')
                return false
                break
        }

        if (depLeg && arrLeg) {
            if (this.state.fullItem) {
                this.props.onUpdateTransportationReservation(depLeg, arrLeg, newDepCity, newArrCity, transItem)
                this.props.onModalHide()
            } else {
                this.props.onAddTransportation(depLeg, arrLeg, newDepCity, newArrCity, transItem, this.props.user)
                this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRANSPORTATION, this.props.availableDetailSubSections.OVERVIEW)
            }
        }
    }

    getForm() {
        let onDateBlur = (evt) => {
            if ((evt.target.id == 'startdate' && this.state.startdate == null) || (
                evt.target.id == 'enddate' && this.state.enddate == null)) {
                evt.target.parentElement.parentElement.className = evt.target.parentElement.parentElement.className.replace( /(?:^|\s)is-focused(?!\S)/g, '' )
            }
        }
        let onDateFocus = (evt) => {
            evt.target.parentElement.parentElement.className = evt.target.parentElement.parentElement.className.replace( /(?:^|\s)is-focused(?!\S)/g, '' )
            evt.target.parentElement.parentElement.className += ' is-focused'
        }

        let depCityInput = <AutoComplete
            type='destination'
            onExecuteQuery={this.onExecuteQuery}
            onRenderResult={this.onRenderResult}
            onChoose={this.onChooseDep}
            hideEmpty={true}
            searchClass='user-entry'
            searchId="-dep"
            placeholder='Departure City'
            ref="depcityinput"/>

        let arrCityInput = <AutoComplete
            type='destination'
            onExecuteQuery={this.onExecuteQuery}
            onRenderResult={this.onRenderResult}
            onChoose={this.onChooseArr}
            hideEmpty={true}
            searchClass='user-entry'
            searchId="-arr"
            placeholder='Arrival City'
            ref="arrcityinput"/>

        // override
        if (this.state.fullItem && this.state.fullItem.get('depCity')) {
            depCityInput = <div className="form-group input-plain">
                <h1>{this.fullItem.getIn(['depCity', 'name'])}</h1>
                <input
                    type="hidden"
                    name="search-destinations-dep"
                    className="form-control input-medium"
                    ref="depcityinput"
                    value={this.state.depCity.get('name')}
                    onChange={() => {this.handleChange('depcity', this.refs.depcity.value)}}/>
            </div>
        }
        if (this.state.fullItem && this.state.fullItem.get('arrCity')) {
            arrCityInput = <div className="form-group input-plain">
                <h1>{this.state.fullItem.getIn(['arrCity', 'name'])}</h1>
                <input
                    type="hidden"
                    name="search-destinations-arr"
                    className="form-control input-medium"
                    ref="arrcityinput"
                    value={this.state.arrCity.get('name')}
                    onChange={() => {this.handleChange('arrcity', this.refs.arrcity.value)}}/>
            </div>
        }

        let startDate = typeof(this.state.startdate) === 'string'
            ? moment(this.state.startdate)
            : this.state.startdate
        let endDate = typeof(this.state.enddate) === 'string'
            ? moment(this.state.enddate)
            : this.state.enddate

        return (
            <div className="">

                <div className="row">
                    <div className="col-sm-6">
                        { depCityInput }
                    </div>
                    <div className="col-sm-6">
                        { arrCityInput }
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group input-plain">
                            <label htmlFor="confirmation_code">Name/Description</label>
                            <input
                                type="text"
                                name="transname"
                                className="form-control input-medium"
                                ref="transname"
                                value={this.state.transname}
                                onChange={() => {this.handleChange('transname', this.refs.transname.value)}}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="confirmation_code">Confirmation Number</label>
                            <input
                                type="text"
                                name="confirmation_code"
                                className="form-control input-medium"
                                ref="confirmation_code"
                                value={this.state.confirmation_code}
                                onChange={() => {this.handleChange('confirmation_code', this.refs.confirmation_code.value)}}/>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="transittype">Transit Type</label>
                            <input
                                type="text"
                                name="transittype"
                                className="form-control input-medium"
                                ref="transittype"
                                value={this.state.transittype}
                                onChange={() => {this.handleChange('transittype', this.refs.transittype.value)}}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="numguests">Number of Guests</label>
                            <input
                                type="text"
                                name="numguests"
                                className="form-control input-medium"
                                ref="numguests"
                                value={this.state.numguests}
                                onChange={() => {this.handleChange('numguests', this.refs.numguests.value)}}/>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="transittype">Carrier Name</label>
                            <input
                                type="text"
                                name="carrier"
                                className="form-control input-medium"
                                ref="carrier"
                                value={this.state.carrier}
                                onChange={() => {this.handleChange('carrier', this.refs.carrier.value)}}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="startdate">Start Date</label>
                            <DatePicker
                                name='startdate'
                                dateFormat='MMMM D, YYYY'
                                className='form-control input-medium'
                                isClearable={false}
                                onFocus={onDateFocus}
                                onBlur={onDateBlur}
                                selected={startDate}
                                ref="startdate"
                                value={startDate || ''}
                                onChange={this.updateStartDate}/>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="starttime">Start Time</label>
                            <input
                                type="text"
                                name="starttime"
                                className="form-control input-medium"
                                ref="starttime"
                                value={this.state.starttime}
                                onChange={() => {this.handleChange('starttime', this.refs.starttime.value)}}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="enddate">End Date</label>
                            <DatePicker
                                name='enddate'
                                dateFormat='MMMM D, YYYY'
                                className='form-control input-medium'
                                isClearable={false}
                                onFocus={onDateFocus}
                                onBlur={onDateBlur}
                                selected={endDate}
                                ref="enddate"
                                value={endDate || ''}
                                onChange={this.updateEndDate}/>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group input-plain">
                            <label htmlFor="endtime">End Time</label>
                            <input
                                type="text"
                                name="endtime"
                                className="form-control input-medium"
                                ref="endtime"
                                value={this.state.endtime}
                                onChange={() => {this.handleChange('endtime', this.refs.endtime.value)}}/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <h2>Notes</h2>
                        <div className="form-group input-plain text-area">
                            <textarea
                                name="notes"
                                className="form-control input-medium"
                                ref="notes"
                                value={this.state.notes}
                                onChange={() => {this.handleChange('notes', this.refs.notes.value)}}/>
                            <br/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group">
                        <button
                            type="submit"
                            onClick={() => { this.submitCustomItem() }}
                            className="btn btn-medium btn-blue">
                Save Details
                        </button>
                    </div>
                </div>
            </div>
        )
    }




    render() {
        if (this.props.isModal) {
            return ( <div ref="entryform" className="modal-form">{ this.getForm() }</div> )
        } else {
            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.goBack() } className="btn">Go Back</a>
                    </div>
                    <div className="view-center">
                        <div className="label-block">
                            <h1>MY TRANSPORTATION DETAILS</h1>
                        </div>
                        <div className="row">
                            { this.getForm() }
                        </div>
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        }
    }
}
